import { render } from "./SpannungsabfallWechselstrom.vue?vue&type=template&id=435aec8c"
import script from "./SpannungsabfallWechselstrom.vue?vue&type=script&lang=js"
export * from "./SpannungsabfallWechselstrom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__